import { useMemo, useRef } from "react";
import * as Yup from "yup";

import { DEFAULT_USER_DATA } from "../../../constants/auth/sign-up";
import { PLACEHOLDER_EDUCATION } from "../../../constants/auth/sign-up";
import { useFormState } from "./index";
import { getPhoneRegexForCountry, getPhoneErrorMessageForCountry } from "../../../helpers/phoneHelper";

export function useSignupForm() {
  /* Stable refs for autofill prevention */
  const fieldRefs = {
    fullname: useRef(null),
    email: useRef(null),
    password: useRef(null),
    phonenumber: useRef(null),
    dob: useRef(null),
  };

  const [userData, setUserData] = useFormState(DEFAULT_USER_DATA);

  const inputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  // Schema updates dynamically when country changes
  const validationSchema = useMemo(
    () => {
      const countryName = userData?.country;
      const phoneRegex = getPhoneRegexForCountry(countryName);
      const phoneError = getPhoneErrorMessageForCountry(countryName);

      return Yup.object({
        fullname: Yup.string()
          .min(3, "Minimum 3 characters required")
          .max(25, "Maximum 25 characters allowed")
          .required("Name is required"),
        email: Yup.string()
          .email("Invalid email address")
          .required("Email is required"),
        password: Yup.string()
          .min(8, "Must be 8 characters or more")
          .required("Password is required"),
        phonenumber: Yup.string()
          .matches(phoneRegex, phoneError)
          .required("Phone number is required"),
        country: Yup.string().required("Country is required"),
        state: Yup.string().required("State is required"),
        city: Yup.string().required("City is required"),
        dob: Yup.date()
          .max(new Date(), "Date of birth cannot be in the future")
          .required("Date of birth is required"),
        gender: Yup.string().required("Gender is required"),
        acceptTerms: Yup.bool().oneOf(
          [true],
          "Accept Terms & Conditions is required",
        ),
      });
    },
    [userData?.country]
  );

  return { userData, setUserData, inputChange, validationSchema, fieldRefs };
}
